import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

export const tableConstants = (permissions, onEdit, onDelete, onViewPrograms) => [
  {
    title: "SNo",
    render: (_rowData, rowIndex) => <span>{rowIndex + 1}</span>,
  },
  {
    title: "Name",
    render: (rowData) => <span>{rowData.name}</span>,
  },
  {
    title: "Programs",
    render: (rowData) => {
      const programCount = (rowData.programs || [])
        .map((item) => item?.name || item?.program?.name)
        .filter(Boolean).length;

      return (
        <button
          type="button"
          className="meeting-program-count-btn"
          onClick={() => onViewPrograms(rowData)}
        >
          {programCount} {programCount === 1 ? "Program" : "Programs"}
        </button>
      );
    },
  },
  {
    title: "Action",
    render: (rowData) => (
      <span>
        {permissions.includes("meeting.with.type.update") && (
          <FontAwesomeIcon
            icon={faEdit}
            style={{ color: "var(--color-primary-text)", marginRight: "10px", cursor: "pointer" }}
            onClick={() => onEdit(rowData)}
          />
        )}
        {permissions.includes("meeting.with.type.delete") && (
          <FontAwesomeIcon
            icon={faTrashAlt}
            style={{ color: "var(--color-danger-text)", marginRight: "10px", cursor: "pointer" }}
            onClick={() => {
              if (window.confirm("Are you sure you wish to delete this item?")) {
                onDelete(rowData);
              }
            }}
          />
        )}
      </span>
    ),
  },
];
